import { WagoApiClient } from '@shared/service/wago-api.client';
import { ModelConversionService } from '@shared/convert/model-conversion.service';
import { TextSizeCheckRequestResponseVO, TextSizeCheckRequestVO } from '../manager/text-size-check.vo';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TextSizeCheckService {

  constructor(
    private modelConversionService: ModelConversionService,
    private wagoApiClient: WagoApiClient
  ) {}

  public getTextSizeCheckRequestResponse(textSizeCheckRequests: TextSizeCheckRequestVO[]): Observable<TextSizeCheckRequestResponseVO[]> {
    return this.wagoApiClient.post('text-size-check/grouped/search/by-requests',
      textSizeCheckRequests).pipe(
        map((json: any) => this.modelConversionService.convertTextSizeCheckRequestResponseVOs(json)));
  }
}
